import React from 'react';
import Countdown from '../../../../components/Countdown/Countdown';
import ImageSlider from '../../../../components/ImageSlider/ImageSlider';
import LeadForm from '../../../../components/LeadForm/LeadForm';
import { useStateContext } from '../../../../context/ContextProvider';
import LanguageNavigate from '../../../../components/Language/LanguageNavigate';
import Footer from '../../../../components/Footer/Footer';
import NoiseBackground from '../../../../components/Background/NoiseBackground';
import Height15 from '../../../../components/Gap/Height';
import HikalLeadForm from '../../../../components/LeadForm/HikalLeadForm';
import HikalLeadFormLuxury from '../../../../components/LeadForm/HikalLeadFormLuxury';
import BelalLeadFormLuxury from '../../../../components/LeadForm/BelalLeadFormLuxury';

function AziziMilanHikal({
    language
}) {
    const {
        langs,
        langCode,
        userInfo
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const poster = "/assets/images/projects/azizi-milan/1.webp";
    const webm = "/assets/images/projects/azizi-milan/hero.webm";
    const mp4 = "/assets/images/projects/azizi-milan/hero.mp4";

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isIraq = userInfo?.countryName == "Iraq";
    const isIran = userInfo?.countryName == "Iran";
    const isTurkey = userInfo?.countryName == "Turkey";

    return (
        <>
            <div>
                <NoiseBackground />

                {/* LANGUAGE */}
                <LanguageNavigate
                    support={["en", "ar", "fa", "tr"]}
                    redirect={{
                        en: "/projects/azizi/milan",
                        ar: "/projects/azizi/milan/ar",
                        fa: "/projects/azizi/milan/fa",
                        tr: "/projects/azizi/milan/tr",
                    }}
                />

                {/* IMAGES */}
                <div className="fixed top-0 left-0 w-full flex justify-center -z-1 lg:hidden" style={{ zIndex: 0 }}>
                    <video
                        autoPlay={true}
                        loop={true}
                        muted={true}
                        playsInline={true}
                        preload="auto"
                        poster={poster}
                        width="350"
                        height="350"
                        className={`w-full md:max-w-[550px]`}
                    >
                        <source src={webm} type="video/webm" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:px-[7%]">
                    <div className="h-full w-full items-center justify-center hidden lg:flex">
                        <video
                            autoPlay={true}
                            loop={true}
                            muted={true}
                            playsInline={true}
                            preload="auto"
                            poster={poster}
                            width="350"
                            height="350"
                            className={`w-full md:max-w-[550px] rounded-sm`}
                        >
                            <source src={webm} type="video/webm" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                    <div className="relative px-[7%] lg:px-0 text-center my-5 py-5 z-1 flex flex-col gap-10 items-center" style={{ zIndex: 1 }}>
                        <div className="h-[300px] md:h-[400px] lg:h-0"></div>
                        <div className="luxury-card flex flex-col gap-10 py-6">
                            <div className="px-2">
                                {language === "ar"
                                    ? (isUAE ? (
                                        <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                            فرصتك للتملك في قلب دبي
                                            <br />
                                            <span className="text-2xl bounce-text secondary-text">بأقساط5800</span>
                                            درهم فقط
                                            <br />
                                            سجل بياناتك وهنرسلك التفاصيل
                                        </h1>
                                    ) : isIraq ? (
                                        <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                            فرصتك للتملك في قلب دبي
                                            <br />
                                            بأقساط
                                            <span className="text-2xl bounce-text secondary-text">1600</span>
                                            دولار فقط
                                            <br />
                                            سجل بياناتك وهنرسلك التفاصيل
                                        </h1>
                                    ) : isIran ? (
                                        <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                            فرصتك للتملك في قلب دبي
                                            <br />
                                            بأقساط
                                            <span className="text-2xl bounce-text secondary-text">1300</span>
                                            يورو شهريا فقط
                                            <br />
                                            سجل بياناتك وهنرسلك التفاصيل
                                        </h1>
                                    ) : isTurkey ? (
                                        <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                            فرصتك للتملك في قلب دبي
                                            <br />
                                            بأقساط
                                            <span className="text-2xl bounce-text secondary-text">1300</span>
                                            يورو شهريا فقط
                                            <br />
                                            سجل بياناتك وهنرسلك التفاصيل
                                        </h1>
                                    ) : (
                                        <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                            فرصتك للتملك في قلب دبي
                                            <br />
                                            بأقساط
                                            <span className="text-2xl bounce-text secondary-text">1600</span>
                                            دولار فقط
                                            <br />
                                            سجل بياناتك وهنرسلك التفاصيل
                                        </h1>
                                    ))
                                    : language === "tr"
                                        ? (isUAE ? (
                                            <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                Dubai’nin kalbinde yer alan projeden,
                                                <br />
                                                sadece aylık
                                                <span className="text-2xl bounce-text secondary-text">5.800 AED</span>
                                                taksitlerle mülk sahibi olma fırsatını yakalayın!
                                                <br />
                                                Bilgileri almak için hemen kayıt olun.
                                            </h1>
                                        ) : isIraq ? (
                                            <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                Dubai’nin kalbinde yer alan projeden,
                                                <br />
                                                sadece aylık
                                                <span className="text-2xl bounce-text secondary-text">1.600 USD</span>
                                                taksitlerle mülk sahibi olma fırsatını yakalayın!
                                                <br />
                                                Bilgileri almak için hemen kayıt olun.
                                            </h1>
                                        ) : isIran ? (
                                            <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                Dubai’nin kalbinde yer alan projeden,
                                                <br />
                                                sadece aylık
                                                <span className="text-2xl bounce-text secondary-text">1.300 EUR</span>
                                                taksitlerle mülk sahibi olma fırsatını yakalayın!
                                                <br />
                                                Bilgileri almak için hemen kayıt olun.
                                            </h1>
                                        ) : isTurkey ? (
                                            <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                Dubai’nin kalbinde yer alan projeden,
                                                <br />
                                                sadece aylık
                                                <span className="text-2xl bounce-text secondary-text">1.300 EUR</span>
                                                taksitlerle mülk sahibi olma fırsatını yakalayın!
                                                <br />
                                                Bilgileri almak için hemen kayıt olun.
                                            </h1>
                                        ) : (
                                            <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                Dubai’nin kalbinde yer alan projeden,
                                                <br />
                                                sadece aylık
                                                <span className="text-2xl bounce-text secondary-text">1.600 USD</span>
                                                taksitlerle mülk sahibi olma fırsatını yakalayın!
                                                <br />
                                                Bilgileri almak için hemen kayıt olun.
                                            </h1>
                                        ))
                                        : language === "fa"
                                            ? (isUAE ? (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                                    فرصت ويژه برای خرید ملک در قلب دبی
                                                    <br />
                                                    با اقساط فقط ۵۸۰۰ درهم
                                                    <br />
                                                    لطفاً مشخصات خود را ثبت کنید تا اطلاعات برایتان ارسال شود.
                                                    {/* <span className="text-2xl bounce-text secondary-text">AED 5800</span> */}
                                                </h1>
                                            ) : isIraq ? (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                                    فرصت ويژه برای خرید ملک در قلب دبی
                                                    <br />
                                                    با اقساط فقط ۱۶۰۰ دلار
                                                    <br />
                                                    لطفاً مشخصات خود را ثبت کنید تا اطلاعات برایتان ارسال شود.
                                                </h1>
                                            ) : isIran ? (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                                    فرصت ويژه برای خرید ملک در قلب دبی
                                                    <br />
                                                    با اقساط فقط ١٣٠٠ يورو
                                                    <br />
                                                    لطفاً مشخصات خود را ثبت کنید تا اطلاعات برایتان ارسال شود.
                                                </h1>
                                            ) : isTurkey ? (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                                    فرصت ويژه برای خرید ملک در قلب دبی
                                                    <br />
                                                    با اقساط فقط ١٣٠٠ يورو
                                                    <br />
                                                    لطفاً مشخصات خود را ثبت کنید تا اطلاعات برایتان ارسال شود.
                                                </h1>
                                            ) : (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl lg:text-2xl">
                                                    فرصت ويژه برای خرید ملک در قلب دبی
                                                    <br />
                                                    با اقساط فقط ۱۶۰۰ دلار
                                                    <br />
                                                    لطفاً مشخصات خود را ثبت کنید تا اطلاعات برایتان ارسال شود.
                                                </h1>
                                            ))
                                            : (isUAE ? (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                    Your opportunity to own property in the heart of Dubai
                                                    <br />
                                                    with installments of
                                                    <span className="text-2xl bounce-text secondary-text">AED 5800</span>
                                                    only
                                                    <br />
                                                    Register your details and we will send you the information
                                                </h1>
                                            ) : isIraq ? (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                    Your opportunity to own property in the heart of Dubai
                                                    <br />
                                                    with installments of
                                                    <span className="text-2xl bounce-text secondary-text">USD 1600</span>
                                                    only
                                                    <br />
                                                    Register your details and we will send you the information
                                                </h1>
                                            ) : isIran ? (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                    Your opportunity to own property in the heart of Dubai
                                                    <br />
                                                    with installments of
                                                    <span className="text-2xl bounce-text secondary-text">EUR 1300</span>
                                                    only
                                                    <br />
                                                    Register your details and we will send you the information
                                                </h1>
                                            ) : isTurkey ? (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                    Your opportunity to own property in the heart of Dubai
                                                    <br />
                                                    with installments of
                                                    <span className="text-2xl bounce-text secondary-text">EUR 1300</span>
                                                    only
                                                    <br />
                                                    Register your details and we will send you the information
                                                </h1>
                                            ) : (
                                                <h1 className="goldentext text-center px-1 my-1 pb-3 text-xl">
                                                    Your opportunity to own property in the heart of Dubai
                                                    <br />
                                                    with installments of
                                                    <span className="text-2xl bounce-text secondary-text">USD 1600</span>
                                                    only
                                                    <br />
                                                    Register your details and we will send you the information
                                                </h1>
                                            ))
                                }
                            </div>

                            {/* LIMITED TIME OFFER */}
                            <div className="w-full px-4">
                                <div className="padding-container flex items-center justify-center">
                                    <Countdown addClass={"-luxury"} />
                                </div>
                            </div>

                            {/* LEAD FORM */}
                            <div className="w-full px-4">
                                {/* LEAD FORM */}
                                {language === "tr" ? (
                                    <BelalLeadFormLuxury
                                        developer="Azizi"
                                        project="Milan"
                                        leadType="Apartment"
                                        language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                                        enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"]}
                                        assignedToManager={2}
                                        assignedToSales={3}
                                    />
                                ) : (
                                    <HikalLeadFormLuxury
                                        developer="Azizi"
                                        project="Milan"
                                        leadType="Apartment"
                                        language={language === "ar" ? "Arabic" : language === "fa" ? "Farsi" : language === "tr" ? "Turkish" : "English"}
                                        enquiries={["Studio", "1 Bedroom", "2 Bedrooms", "3 Bedrooms"]}
                                        assignedToManager={language == "fa" ? 120 : null}
                                        assignedToSales={language == "fa" ? 518 : null}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default AziziMilanHikal;
